import { throwError, timer } from 'rxjs';
import { mergeMap, retryWhen } from 'rxjs/operators';
/**
 * Implementation of the "Decorrelated Jitter" strategy described here:
 * https://aws.amazon.com/blogs/architecture/exponential-backoff-and-jitter
 */
export class CoralRetryInterceptor {
    /**
     * @param options
     * @param options.doNotRetryHttpStatuses
     * @param options.maxDelay 0 default delay, any negative values will be set to 0
     * @param options.maxRetries Defaults to 3
     * @param options.seedDelay 0 default delay, any negative values will be set to 0
     */
    constructor(options = {}) {
        this.options = Object.assign({
            doNotRetryHttpStatuses: [],
            maxDelay: 0,
            maxRetries: 3,
            seedDelay: 0,
        }, options);
        this.options.maxDelay = Math.max(0, this.options.maxDelay);
        this.options.seedDelay = Math.max(0, this.options.seedDelay);
    }
    intercept(request, next) {
        let delay = this.options.seedDelay;
        return next.handle(request).pipe(retryWhen(errors => {
            return errors.pipe(mergeMap((error, i) => {
                const currentAttempt = i + 1;
                if (currentAttempt >= this.options.maxRetries ||
                    (error && error.status && this.options.doNotRetryHttpStatuses.includes(error.status))) {
                    return throwError(error);
                }
                delay = Math.min(this.options.maxDelay, Math.max(this.options.seedDelay, delay * 3 * Math.random()));
                return timer(delay);
            }));
        }));
    }
}
